import Main from "../components/layout/Main";
import React from "react";
import {Training} from "../containers/Training/Training";

export const TrainingPage = () => {
    return <Main title="Training"><Training/></Main>
}